import React from 'react';
import Icon, { IconKey } from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import { twMerge } from 'tailwind-merge';

interface Props {
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    dataTestId?: string;
    className?: string;
    iconKey: IconKey;
    buttonTitle: string;
    tooltipLabel?: string;
}

const ButtonWithTitle = ({
    onClick,
    iconKey,
    dataTestId,
    className,
    buttonTitle,
    tooltipLabel,
}: Props) => {
    return (
        <div className="flex flex-col items-center justify-center gap-y-2">
            <IconButton
                dataTestId={dataTestId}
                onClick={onClick}
                className={twMerge(
                    'size-10 rounded-xl bg-gray-600 text-white',
                    className,
                )}
                tooltipLabel={tooltipLabel}
            >
                <Icon iconKey={iconKey} />
            </IconButton>
            <div className="text-xs text-white">{buttonTitle}</div>
        </div>
    );
};

export default React.memo(ButtonWithTitle);
